// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { quoteSummaryCardStyles } from "@guestsupply/Overrides/Components/QuoteSummaryCard";
import { color } from "@guestsupply/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

quoteSummaryCardStyles.dataCells = {
    css: css`
        max-width: unset;
        ${TypographyStyle} {
            color: ${color("text.main")};
            font-weight: normal;
            white-space: nowrap;
            font-size: 13px;
            line-height: 20px;
            &:hover {
                color: ${color("text.main")};
            }
        }
    `,
};

quoteSummaryCardStyles.clickableCell = {
    css: css`
        a > span {
            font-size: 13px;
        }
    `,
};
